export const PATHS = {
  home: '/',
  products: '/products',
  product: '/product/:id',
  productWithVariant: '/product/:id/:variantId',
  chatForm: '/chat/form',
  cart: '/cart',
}
